// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// TODO: Replace with your Firebase project configuration
// You can find these values in your Firebase Console:
// 1. Go to https://console.firebase.google.com/
// 2. Select your project (or create a new one)
// 3. Go to Project Settings > General
// 4. Scroll down to "Your apps" section
// 5. Click on the web app icon (</>)
// 6. Copy the firebaseConfig object

const firebaseConfig = {
  apiKey: "AIzaSyDlBI6ITDdBz-ptvFWVNlmoLFgSYxNgZwY",
  authDomain: "book-my-camera-ab161.firebaseapp.com",
  projectId: "book-my-camera-ab161",
  storageBucket: "book-my-camera-ab161.firebasestorage.app",
  messagingSenderId: "340259590319",
  appId: "1:340259590319:web:73b19360a30ce49691045a",
  measurementId: "G-4M798KCQ5E"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Firestore and get a reference to the service
export const db = getFirestore(app);

export default app;
